export default "__VITE_ASSET__df785559__"